// extracted by mini-css-extract-plugin
module.exports = {"container":"ShowMore_container__V8Ga0","toggle":"ShowMore_toggle__JfOFB","arrow":"ShowMore_arrow__UQAek","expandedToggle":"ShowMore_expandedToggle__GwKNk"};